import { render, staticRenderFns } from "./social-profile.vue?vue&type=template&id=e2313e7a&scoped=true&"
import script from "./social-profile.vue?vue&type=script&lang=js&"
export * from "./social-profile.vue?vue&type=script&lang=js&"
import style0 from "./social-profile.vue?vue&type=style&index=0&id=e2313e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2313e7a",
  null
  
)

export default component.exports